import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  GridProps,
} from '@mui/material';
import { FORM_STYLES, FORM_CLASSES } from '../../../constants';
import TooltipWithClickAway from '../../terminalPicker/TooltipWithClickAway';

interface RadioOption {
  value: string;
  label: string;
}

interface FormikRadioGroupProps {
  name: string;
  label: string;
  value: string;
  onChange: (event: any) => void;
  onBlur: (event: any) => void;
  options: RadioOption[];
  error?: string;
  disabled?: boolean;
  required?: boolean;
  row?: boolean;
  gridProps?: GridProps;
  tooltipText?: string;
  tooltipKey?: string;
}

const FormikRadioGroup: React.FC<FormikRadioGroupProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  options,
  error,
  disabled = false,
  required = false,
  row = true,
  gridProps = { xs: 12, md: 4 },
  tooltipText,
  tooltipKey,
}) => {
  return (
    <Grid item {...gridProps}>
      <FormControl 
        component="fieldset" 
        className={FORM_CLASSES.FORM_CONTROL}
        error={!!error}
      >
        <FormLabel 
          // component="legend" 
          style={FORM_STYLES.LABEL}
          className={FORM_CLASSES.LABEL_BASE}
        >
          {label} {required && <sup>*</sup>}
          { tooltipText && <>&nbsp;
              <TooltipWithClickAway
                tooltipText={tooltipText}
                tooltipKey={"tooltip-" + tooltipKey}
              /></>}
        </FormLabel>
        <RadioGroup
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          row={row}
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio disabled={disabled} />}
              checked={value === option.value}
              label={option.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
        {error && <span className={"form-error"}>{error}</span>}
        
      </FormControl>
    </Grid>
  );
};

export default FormikRadioGroup;